import React from 'react';
import { Icon } from 'semantic-ui-react';

export const CONTENT_TYPE_ICON_ITEMS = [
  { name: 'image', title: 'Фотография' },
  { name: 'images', title: 'Галерея' },
  { name: 'camera', title: 'Камера' },
  { name: 'video', title: 'Видео' },
  { name: 'video camera', title: 'Видеокамера' },
  { name: 'film', title: 'Фильм' },
  { name: 'briefcase', title: 'Кейс' },
  { name: 'file alternate outline', title: 'Документ' },
  { name: 'file text outline', title: 'Текст' },
  { name: 'newspaper outline', title: 'Статья' },
  { name: 'pencil alternate', title: 'Редактирование' },
  { name: 'paint brush', title: 'Дизайн' },
  { name: 'magic', title: 'Креатив' },
  { name: 'bullhorn', title: 'Анонс' },
  { name: 'announcement', title: 'Объявление' },
  { name: 'share alternate', title: 'Репост' },
  { name: 'share square', title: 'Шеринг' },
  { name: 'thumbs up outline', title: 'Лайк' },
  { name: 'comment outline', title: 'Комментарий' },
  { name: 'comments outline', title: 'Обсуждение' },
  { name: 'hashtag', title: 'Хештег' },
  { name: 'globe', title: 'Веб' },
  { name: 'linkify', title: 'Ссылка' },
  { name: 'microphone', title: 'Подкаст' },
  { name: 'volume up', title: 'Аудио' },
  { name: 'music', title: 'Музыка' },
  { name: 'headphones', title: 'Наушники' },
  { name: 'play', title: 'Воспроизведение' },
  { name: 'play circle outline', title: 'Плеер' },
  { name: 'tv', title: 'ТВ' },
  { name: 'desktop', title: 'Десктоп' },
  { name: 'mobile alternate', title: 'Мобильный' },
  { name: 'tablet alternate', title: 'Планшет' },
  { name: 'instagram', title: 'Instagram' },
  { name: 'youtube', title: 'YouTube' },
  { name: 'facebook', title: 'Facebook' },
  { name: 'twitter', title: 'Twitter' },
  { name: 'telegram plane', title: 'Telegram' },
  { name: 'vk', title: 'VK' },
  { name: 'star outline', title: 'Избранное' },
  { name: 'heart outline', title: 'Избранное (сердце)' },
  { name: 'bookmark outline', title: 'Закладка' },
  { name: 'flag outline', title: 'Флаг' },
  { name: 'trophy', title: 'Достижение' },
  { name: 'chart bar outline', title: 'Аналитика' },
  { name: 'chart line', title: 'График' },
  { name: 'shopping cart', title: 'Товар' },
  { name: 'gift', title: 'Подарок' },
  { name: 'calendar outline', title: 'Событие' },
  { name: 'clock outline', title: 'Время' },
  { name: 'map marker alternate', title: 'Локация' },
  { name: 'users', title: 'Аудитория' },
  { name: 'user outline', title: 'Пользователь' },
  { name: 'lightbulb outline', title: 'Идея' },
  { name: 'rocket', title: 'Запуск' },
  { name: 'fire', title: 'Тренд' },
  { name: 'bolt', title: 'Быстро' },
  { name: 'puzzle piece', title: 'Интеграция' },
  { name: 'cogs', title: 'Настройки' },
  { name: 'folder outline', title: 'Папка' },
  { name: 'copy outline', title: 'Копия' },
  { name: 'clone outline', title: 'Дубликат' },
  { name: 'tasks', title: 'Задачи' },
  { name: 'list ul', title: 'Список' },
  { name: 'check square outline', title: 'Чеклист' },
  { name: 'eye', title: 'Просмотры' },
];

export const buildContentTypeIconOption = (name, title, optionClassName) => ({
  key: name,
  value: name,
  text: title,
  content: (
    <span className={optionClassName}>
      <Icon name={name} />
      <span>{title}</span>
    </span>
  ),
});

export const searchContentTypeIconOptions = (options, query) => {
  const normalized = String(query || '')
    .trim()
    .toLowerCase();
  if (!normalized) {
    return options;
  }

  return options.filter((option) => {
    const text = String(option.text || '').toLowerCase();
    const value = String(option.value || '').toLowerCase();
    return text.includes(normalized) || value.includes(normalized);
  });
};

export const getContentTypeIconTitle = (iconName) => {
  const item = CONTENT_TYPE_ICON_ITEMS.find((entry) => entry.name === iconName);
  return item?.title || iconName || '';
};
